import Flex from "frontend/commons/Flex"

const PaymentSummaryRow = ({ label, value }) => {
  return (
    <Flex style={{ justifyContent: "space-between", gap: "1rem" }}>
      <p>{label}</p>
      <p>{value}</p>
    </Flex>
  )
}

export default PaymentSummaryRow
